import React, { useEffect, useState } from "react";
import { Send, CalendarDays } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export default function SocialPackCard() {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/social-pack/preview").then(({ data }) => setD(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/social-pack/send");
      if (data.ok) { toast.success(`Social pack sent to ${data.to}`); load(); } else toast.error(data.detail || "Couldn't send — check the sales inbox below");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  if (!d) return null;
  const n = d.products.length + d.posts.length + (d.pup ? 1 : 0);
  const last = d.last?.sent_at ? new Date(d.last.sent_at).toLocaleDateString("en-AU", { day: "numeric", month: "short" }) : null;
  return (
    <div className="bg-white rounded-3xl soft-shadow p-6 mb-4" data-testid="social-pack-card">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h3 className="font-display font-bold text-[#19324A] inline-flex items-center gap-2"><CalendarDays className="w-4 h-4" /> Weekly social pack</h3>
          <p className="text-xs text-[#19324A]/50 mt-1">Every Monday 8:30am we email your sales inbox a bundle of ready-to-post cards with one-tap Facebook links. {last ? `Last sent ${last}${d.last?.sent ? "" : " (failed)"}.` : "Not sent yet."}</p>
        </div>
        <button type="button" onClick={send} disabled={busy} className="btn-pink !py-2 text-sm inline-flex items-center gap-1.5" data-testid="social-pack-send"><Send className="w-4 h-4" /> {busy ? "Sending…" : "Email me this week's pack"}</button>
      </div>
      <p className="text-xs font-bold uppercase tracking-wider text-[#19324A]/50 mt-4 mb-2">This week's pack · {n} cards</p>
      <ul className="text-sm text-[#19324A] space-y-1" data-testid="social-pack-items">
        {d.products.map((p) => <li key={p.slug} data-testid={`social-pack-product-${p.slug}`}>🛍️ {p.name} — ${p.price.toFixed(2)} {p.new && <span className="ml-1 text-[10px] font-extrabold text-[#FF6B9D]">NEW</span>}</li>)}
        {d.posts.map((b) => <li key={b.slug} data-testid={`social-pack-post-${b.slug}`}>📖 {b.title} {b.new && <span className="ml-1 text-[10px] font-extrabold text-[#FF6B9D]">NEW</span>}</li>)}
        {d.pup && <li data-testid="social-pack-pup">🐾 {d.pup.title}</li>}
      </ul>
    </div>
  );
}
